import { render } from "./megaSpinner.vue?vue&type=template&id=f3996592&scoped=true&ts=true"
import script from "./megaSpinner.vue?vue&type=script&lang=ts"
export * from "./megaSpinner.vue?vue&type=script&lang=ts"

import "./megaSpinner.vue?vue&type=style&index=0&id=f3996592&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3996592"]])

export default __exports__